(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rfq-quote-form"] && !Shopify.designMode) return;
  try {
    
  const notes = document.querySelector('#rfq-message');
  const body = document.querySelector('[data-rfq-body]');
  if (notes && body) {
    const requestedProduct = new URLSearchParams(window.location.search).get('product');
    if (requestedProduct && !notes.value) notes.value = 'Product inquiry: ' + requestedProduct;
    const base = body.value;
    const sync = () => {
      const extra = notes.value.trim();
      body.value = extra ? `${base}\n\nNotes:\n${extra}` : base;
    };
    notes.addEventListener('input', sync);
    notes.form.addEventListener('submit', function () {
      sync();
try { sessionStorage.setItem('linko_rfq_pending', (new URLSearchParams(location.search).get('lk_test') === '1' ? 'test-' : '') + String(Date.now())); } catch (e) {}
    });
    sync();
  }

  } catch(e) { console.error(e); }
})();
})();
